import { useMutation, useQueryClient } from "@tanstack/react-query";

import { listsQueryKeys } from "app/pages/sales-intelligence/modules/lists/sub-modules/my-list/services/queries/queryKeyFactory";
import { crmListsQueryKeys } from "app/pages/sales-intelligence/modules/lists/sub-modules/crm-list/services/queries/queryKeyFactory";
import type {
    DigestSubscription,
    UpdateDigestSubscriptionDTO,
} from "app/pages/sales-intelligence/sub-modules/signals-alerts/models/DigestSubscription";
import signalsAlertsAPIService from "app/pages/sales-intelligence/sub-modules/signals-alerts/services/api/signalsAlertsAPIService";

export default function useSignalsAlertsCancellationMutation() {
    const queryClient = useQueryClient();

    return useMutation<DigestSubscription, unknown, UpdateDigestSubscriptionDTO>({
        mutationFn(dto) {
            return signalsAlertsAPIService.updateDigestSubscription(dto);
        },
        onSuccess() {
            void queryClient.invalidateQueries({ queryKey: listsQueryKeys.allStaticLists() });
            void queryClient.invalidateQueries({ queryKey: crmListsQueryKeys.all() });
        },
    });
}
